import { Button } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./Login.module.css";
import logo from "../../../assets/images/logo.png";

import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { showAlert, showLoading } from "../../../Store/Actions/GeneralActions";
import { getUser, isLogin } from "../../../Store/Actions/AuthAction";
import Storage from "../../../utills/AsyncStorage";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { validateEmail } from "../../../utills/Validators";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState({
    value: "Admin",
    role: "admin",
    id: 1,
  });
  const [passwordVisible, setPasswordVisible] = useState(false);

  console.log("Role ", role?.role);

  const onPressLogin = () => {
    localStorage.setItem("@user", { role: role.role });
    localStorage.setItem("@token", "contractor");
    localStorage.setItem("@role", role.role);
    dispatch(isLogin(true));
    dispatch(getUser({ role: role.role }));
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <div className={styles.textDiv}>
            <TextComponent
              text={"Welcome"}
            className={styles.Heading}
              padding={"0px"}
            />

            <TextComponent
              className={styles.welcomeText}
              color={"var(--white-color)"}
              text={"Login to proceed"}
            />
          </div>
          <div className={styles.inputDiv}>
            <InputField
              className={styles.input}
              label={"Email Address"}
              labelClass={styles.labelClass}
              placeholder={"chris@email.com"}
              LabelColor={"var(--white-color)"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <InputField
              className={styles.input}
              labelClass={styles.labelClass}
              label={"Password"}
              placeholder={"●●●●●●●●●●"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              rightIcon={
                passwordVisible ? (
                  <LuEye size={20} color={"var(--input-icon)"} />
                ) : (
                  <LuEyeOff size={20} color={"var(--input-icon)"} />
                )
              }
              onRightIconPress={() => setPasswordVisible(!passwordVisible)}
              type={passwordVisible ? "text" : "password"}
            />
            <Dropdown
              className={styles.input}
              label={"Role"}
              labelClass={styles.labelClass}
              value={role}
              style={{ color: "var(--black-color)" }}
              options={[
                {
                  value: "Admin",
                  role: "admin",
                  id: 1,
                },
                {
                  value: "Supervisor",
                  role: "supervisor",
                  id: 2,
                },
                {
                  value: "Staff Member",
                  role: "staff",
                  id: 3,
                },
              ]}
              onChange={(e) => setRole(e)}
            />
          </div>
          <div className={styles.btn}>
            <SubmitButton
              title={"Login"}
              onClick={onPressLogin}
              primary
              btnContainerClass={styles.Login_btnContainer}
              textClass={styles.Login_Text}
              btnClass={`${styles.Login_btn}`}
            />
          </div>
          <div className={styles.forgotText}>
            <TextComponent
              onClick={() => navigate("/forgotPassword")}
              style={{ marginTop: "15px", color: "var(--white-color)" , cursor: "pointer" }}
              text={"Forgot Password?"}
            />
          </div>
          {role?.value === "Admin" && (
            <div className={styles.signUDiv}>
              <TextComponent
                style={{ color: "var(--white-color)"  }}
                text={"Don’t have an account? "}
              />
              <TextComponent
                style={{ color: "var(--white-color)", cursor: "pointer" }}
                onClick={() => navigate("/signupCode")}
                text={" Signup"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
